module.exports = require("./teo.d.ts");